var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.code)?_c('Konami',{key:"konami",attrs:{"konami":_vm.selection.konami}}):_c('CmpRenderer',{key:"content",attrs:{"components":_vm.selection.content}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }